import React from 'react';
import { FadeIn } from './FadeIn';
export function TomosSection() {
  const tomos = [{
    num: 'Tomo 1 · Gestión del consultorio',
    title: 'Mi Consultorio, Mi Empresa',
    desc: 'Cómo estructurar el consultorio como un negocio profesional sin dejar de ser clínica.',
    items: ['Honorarios, encuadre y política de cancelación', 'Sistema de turnos sin apps de pago', 'Hoja de ruta del paciente nuevo', 'Finanzas básicas del consultorio']
  }, {
    num: 'Tomo 2 · Documentación clínica',
    title: 'El Historial que te Cuida a Vos y al Paciente',
    desc: 'Sistema completo de registro clínico: anamnesis, evolución de sesiones, objetivos y alta.',
    items: ['Ficha de anamnesis infantil y adulto', 'Planilla de evolución de sesión', 'Plantilla de objetivos terapéuticos', 'Registro de alta y derivación']
  }, {
    num: 'Tomo 3 · Obras sociales y facturación',
    title: 'Cobrar sin Demoras y sin Que te Rechacen la Factura',
    desc: 'El tomo más urgente: cómo facturar correctamente a obras sociales y cobrar en tiempo.',
    items: ['Checklist de documentación con y sin CUD', 'Planilla de asistencia modelo para OS', 'Protocolo ante rechazo de factura', 'Planilla de seguimiento de cobros']
  }, {
    num: 'Tomo 4 · Informes',
    title: 'Escribir Informes en la Mitad del Tiempo',
    desc: 'Estructura y modelos para cada tipo de informe: escolar, semestral, derivación y evolución.',
    items: ['Modelo de informe semestral para OS', 'Modelo de informe para equipo escolar (EOE)', 'Modelo de nota de derivación', 'Banco de frases clínicas por área']
  }, {
    num: 'Tomo 5 · Familias y encuadre',
    title: 'La Primera Entrevista que Pone las Reglas Claras',
    desc: 'Cómo establecer el encuadre con las familias desde el inicio para evitar conflictos.',
    items: ['Guía de primera entrevista (6 momentos)', 'Consentimiento informado modelo', 'Cómo dar diagnósticos difíciles', 'Cómo manejar cancelaciones y deudas']
  }, {
    num: 'Tomo 6 · Organización y sostenibilidad',
    title: 'El Consultorio que Trabaja Cuando Vos Descansás',
    desc: 'Rutinas, calendarios y límites para sostener el consultorio funcionando a largo plazo.',
    items: ['Checklist de apertura y cierre semanal', 'Protocolo de ausencia propia', 'Indicadores mensuales del consultorio', 'Plan de 30 días para implementar el sistema']
  }];
  return <section className="bg-brand-cream py-16 md:py-24 px-4 md:px-6" data-id="element-132">
      <div className="max-w-6xl mx-auto" data-id="element-133">
        <FadeIn data-id="element-134">
          <p className="text-[11px] font-semibold tracking-[0.14em] uppercase text-brand-green mb-3" data-id="element-135">
            Todo lo que incluye Consultorio Fono en Orden
          </p>
          <h2 className="font-serif text-brand-dark text-3xl md:text-[42px] font-bold leading-[1.2]" data-id="element-136">
            6 tomos + 6 bonos
          </h2>
          <div className="w-12 h-[2px] bg-brand-green mt-5 mb-10 md:mb-12" data-id="element-137" />
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-id="element-138">
          {tomos.map((tomo, i) => <FadeIn key={i} delay={i * 0.06} data-id="element-139">
              <div className="bg-brand-white border border-brand-cream-dark rounded-[10px] p-7 h-full hover:border-brand-green/40 hover:shadow-[0_8px_24px_rgba(29,92,74,0.08)] transition-all" data-id="element-140">
                <p className="text-[11px] font-semibold tracking-[0.1em] uppercase text-brand-green mb-2" data-id="element-141">
                  {tomo.num}
                </p>
                <h3 className="font-serif text-brand-dark text-lg md:text-[19px] font-bold leading-snug mb-2.5" data-id="element-142">
                  {tomo.title}
                </h3>
                <p className="text-brand-muted text-[14px] leading-[1.7] mb-4" data-id="element-143">
                  {tomo.desc}
                </p>
                <ul className="space-y-1.5" data-id="element-144">
                  {tomo.items.map((it, idx) => <li key={idx} className="text-brand-muted text-[13px] leading-[1.5] pl-4 relative" data-id="element-145">
                      <span className="absolute left-0 text-brand-green text-[12px]" data-id="element-146">
                        →
                      </span>
                      {it}
                    </li>)}
                </ul>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}